const countries = [
  { code: '+20',  iso: 'eg', name: 'مصر',       placeholder: '100 000 0000' },
  { code: '+966', iso: 'sa', name: 'السعودية',   placeholder: '50 000 0000'  },
  { code: '+971', iso: 'ae', name: 'الإمارات',   placeholder: '50 000 0000'  },
  { code: '+965', iso: 'kw', name: 'الكويت',     placeholder: '9000 0000'    },
  { code: '+974', iso: 'qa', name: 'قطر',        placeholder: '3300 0000'    },
  { code: '+973', iso: 'bh', name: 'البحرين',    placeholder: '3600 0000'    },
  { code: '+968', iso: 'om', name: 'عُمان',      placeholder: '9200 0000'    },
  { code: '+962', iso: 'jo', name: 'الأردن',     placeholder: '79 000 0000'  },
  { code: '+961', iso: 'lb', name: 'لبنان',      placeholder: '70 000 000'   },
  { code: '+44',  iso: 'gb', name: 'UK',         placeholder: '7700 000000'  },
  { code: '+1',   iso: 'us', name: 'USA',        placeholder: '201 000 0000' },
];

export default countries;
